<template>
  <div class="memberManage">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <div class="tabContent manageArea boxs">
      <!-- 筛选框 -->
      <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
        <template slot="otherCom">
          <el-form-item>
            <el-input v-model="searchForm.params.mobile" placeholder="输入预留号码" @keyup.enter.native="handleSearch" maxlength="11" size="medium" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.params.intention" placeholder="请选择用户意向" clearable filterable size="medium">
              <el-option label="未联系" value="0"></el-option>
              <el-option label="感兴趣" value="1"></el-option>
              <el-option label="不感兴趣" value="2"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </sr-filter>
      <div class="botTable tableTheadGray boxs">
        <div class="tableTop">
          <span class="leTableTit">会员列表</span>
          <button class="butStyle pinkBtn exportBtn" @click="tableExportAll">
            <i class="exportIcon"></i>
            <span>导出数据</span>
          </button>
        </div>
        <el-table ref="multipleTable" :data="tableData" @selection-change="selsChange" style="width: 100%;" border fit highlight-current-row tooltip-effect="dark">
          <!-- 这是列表前面的多选框 -->
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column label="预约时间" prop="createTime" min-width="150" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="预约人" prop="fullName" min-width="90" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="预留号码" prop="mobile" min-width="120" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="联系区域" prop="location" min-width="250" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="用户备注" prop="customerRemarks" min-width="250" header-align="center" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column label="用户意向" prop="intention" min-width="100" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="备注" prop="remarks" min-width="300" header-align="center" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column label="时间" prop="updateTime" min-width="150" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" fixed="right" width="244px" header-align="center" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="flex_h_hC_vC">
                <div @click="showFollowWindow(scope.row.id)">
                  <img style="width: 10px;height: 10px;" src="../../../assets/images/appointment/telephone.png">
                  <span class="table-operation-green">营销跟进</span>
                </div>
                <div style="margin-left:15px" @click="showLogWindow(scope.row.id)">
                  <img style="width: 10px;height: 10px;" src="../../../assets/images/appointment/log.png">
                  <span class="table-operation-green">日志</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox boxs">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <baseDialog title="营销跟进" :zIndex="1000" :visible.sync="followWindowOpen" :isFooter="true" :close-on-click-modal="false" @confirmEmit="submitFollowInfo" @closeEmit="closeFollowWindow" width="311px">
      <div class="dialog-input flex_h_hL_vC">
        <label class="flex_h_hL_vC"><b>*</b>用户意向:</label>
        <el-select style="height: 32px; width:220px" v-model="selectIntention" placeholder="请选择" size="small">
          <el-option label="感兴趣" value="1"></el-option>
          <el-option label="不感兴趣" value="2"></el-option>
        </el-select>
      </div>
      <div class="dialog-input flex_h_hL_vC" style="height: 96px; align-items: normal; -webkit-align-items: normal;">
        <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备注:</label>
        <el-input style="width:220px; font-size: 12px;" v-model="remarks" placeholder="请输入备注" maxlength="200" show-word-limit clearable type="textarea" :rows="5" resize="none" @input="e => remarks = validForbid(e)"></el-input>
      </div>
    </baseDialog>

    <baseDialog title="跟进日志" :zIndex="1000" :visible.sync="followListWindowOpen" :isFooter="false" :close-on-click-modal="false" width="440px">
      <div class="botTable tableTheadGray boxs" style="height: 400px; overflow-y: auto;">
        <el-table :data="followListData" ref="multipleTable" style="width: 100%;" border fit highlight-current-row tooltip-effect="dark">
          <el-table-column label="变更内容" prop="intention" min-width="100" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作时间" prop="createTime" min-width="150" header-align="center" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作人" prop="createUserName" min-width="100" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </baseDialog>

  </div>
</template>

<script>
import TitleBox from "@/components/Common/TitleBox/TitleBox.1";
import SrFilter from "@/components/Common/Filter/Filter";
import baseDialog from "@/components/Common/BaseDialog/code/baseDialog";
import {
  getAppointmentList,
  addAppointmentFollow,
  getAppointmentFollowList,
  exportAppointent
} from "@/api/Tbs/Appointment/appointment.js";

// 搜索表格的条件-筛选栏
const defaultSearchForm = {
  params: {
    mobile: null,
    intention: null,
  },
  current: 1,
  size: 10,
};

export default {
  name: "AppointmentIndex",
  data() {
    return {
      topTitle: {
        title: "预约信息管理",
        subTit: "",
      },
      // 表格搜索条件
      searchForm: Object.assign({}, defaultSearchForm),
      total: 0,
      tableData: [],
      // 营销跟进弹窗
      followWindowOpen: false,
      followId: "",
      selectIntention: "",
      remarks: "",
      //跟进日志弹窗
      followListWindowOpen: false,
      followListData: [],
    };
  },
  components: {
    TitleBox,
    SrFilter,
    baseDialog,
  },
  created() {
    this.searchForm = {
      params: {
        mobile: "",
        intention: "",
      },
      current: 1,
      size: 10,
    };
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const result = await getAppointmentList(this.searchForm);
        this.tableData = result.data.records;
        this.total = result.data.total;
        this.tableData.forEach((row) => {
          row.location = row.provide + " " + row.city + " " + row.area;
          switch (row.intention) {
            case 0: {
              row.intention = "未联系";
              break;
            }
            case 1: {
              row.intention = "感兴趣";
              break;
            }
            case 2: {
              row.intention = "不感兴趣";
              break;
            }
          }
        });
        this.total = result.data.total;
        console.log(this.tableData);
      } catch (e) {
        this.$message.error("接口请求失败:" + e.msg);
      }
    },

    // 列表过滤查询
    handleSearch() {
      this.searchForm.current = 1;
      this.loadData();
    },
    selsChange(sels) {
      this.sels = sels
      console.log('this.sels',this.sels);
    },
    //1217导出
    tableExportAll() {    
      if(this.sels== undefined || this.sels== ''){
         this.$message.error('请勾选具体预约信息！！！');
      }else{
        let ids = this.sels.map((item) => item.id).join()
      console.log('id',ids);
        const url = `${this.$baseNewUrl}esaleb-service-tbs/appointment/export/${ids}?accessToken=${this.$accessToken()}`;
        window.open(url, '_blank');
      }      
    },
    // 搜索重置（清空）
    handleReset() {
      this.searchForm = {
        params: {
          mobile: "",
          intention: "",
        },
        current: 1,
        size: 10,
      };
      this.loadData();
    },

    //页脚操作
    handleSizeChange(value) {
      this.searchForm.size = value;
      this.loadData();
    },

    handleCurrentChange(value) {
      this.searchForm.current = value;
      this.loadData();
    },

    // 打开营销跟进弹窗
    showFollowWindow(id) {
      this.followId = id;
      this.followWindowOpen = true;
    },

    // 关闭营销跟进弹窗
    closeFollowWindow() {
      this.followId = "";
      this.selectIntention = "";
      this.remarks = "";
    },

    //提交营销跟进信息
    submitFollowInfo() {
      if (this.selectIntention == "") {
        return this.$msgError("必须选择用户意向！");
      }
      let data = {
        id: this.followId,
        intention: this.selectIntention,
        remarks: this.remarks,
      };
      addAppointmentFollow(data)
        .then((res) => {
          this.followWindowOpen = false;
          this.loadData();
          return this.$msgSuccess("添加营销跟进成功");
        })
        .catch((error) => {
          return this.$msgError("添加营销跟进失败");
        });
    },

    async showLogWindow(id) {
      this.followListWindowOpen = true;
      let result = await getAppointmentFollowList(id);
      this.followListData = result.data;
      this.followListData.forEach((row) => {
        switch (row.intention) {
          case 0: {
            row.intention = "未联系";
            break;
          }
          case 1: {
            row.intention = "感兴趣";
            break;
          }
          case 2: {
            row.intention = "不感兴趣";
            break;
          }
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.memberManage {
  min-width: 1080px;
}

.memberManage .tabContent.manageArea .botTable {
  width: 100%;
  margin-top: 14px;
}

.botTable .tableTop {
  height: 54px;
  padding: 0 12px;
  // display: flex;
  // flex-flow: row wrap;
  // justify-content: space-between;
  // align-items: center;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-bottom: none;
  position: relative;
  line-height: 54px
}

.botTable .tableTop .leTableTit {
  font-size: 15px;
  font-weight: bold;
  color: #2b2727;
}

.botTable .tableTop .rightBox {
  width: auto;
  min-width: 200px; //考虑是否删去
  text-align: right;
  display: inline-block;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
}

.table-operation-green {
  width: 24px;
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 14px;
  color: rgba(45, 186, 165, 1);
  opacity: 1;
  cursor: pointer;
}

.dialog-input label {
  display: block;
  width: 90px;
  font-size: 13px;
  color: #aaaaaa;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
  padding-left: 14px;
}

.dialog-input label b {
  color: #fa6241;
  position: absolute;
  top: 2px;
  left: 6px;
}

.dialog-input {
  width: 100%;
  height: 36px;
  font-size: 13px;
  color: #2b2727;
  margin-bottom: 12px;
  border-radius: 5px;
  position: relative;
}

.pageBox {
  width: 100%;
  padding: 15px 0 10px;
  display: flex;
  justify-content: flex-end;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-top: none;
}

.tableTop .butStyle{
  position:absolute;
  right: 22px;
  top: 12px;
  padding: 7px 10px;
  font-size: 13px;
  background: #FA6241;
  width: inherit;
  height: auto;
  line-height: 0;
  &:hover {
    background-color: rgb(247, 143, 120);
  }
}
.tableTop .butStyle>span{
  font-size: 13px;
}
.tableTop .butStyle > i{
  font-size: 15px;
}
.tableTop .exportBtn .exportIcon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
  background-size: 14px 14px;
}
</style>
